import { BaseUtils } from "tnbase";
import { addLayer, findLayersInProjectUuid } from "@/declare/api/geometry/layer";
import { Layer } from "@/declare/interface/project/layer";
import { EngineStatus } from "@/store/engine-store";

/**
 * 将图元布置在单独的图层,
 * 若当前有图元图层，则布置在图元图层,
 * 否则，添加一个图层
 */
export function getSpecialPrimitiveLayerUuid(projectUuid: string, layerName: string, engineContext: EngineStatus, color: string = "#000000") {
    return new Promise((resolve, reject) => {
        findLayersInProjectUuid(projectUuid).then(res => {
            let layers: Layer[] = res.data || [];
            // let idx = engineContext.layers?.findIndex(item => item.name === layerName);
            let idx = layers?.findIndex(item => item.name === layerName);
            if (idx === -1) {
                let uuid = BaseUtils.genUUID();
                let newLayer: Layer = {
                    uuid: uuid,
                    name: layerName,
                    color: color,
                    lock: true,
                    hidden: false,
                    originLayer: false,
                    projectUuid: projectUuid
                };
                addLayer(projectUuid, newLayer).then(_ => {
                    // 注册到图形引擎中
                    if (engineContext?.engine) {
                        let newLayers = [...layers, newLayer];
                        engineContext.setLayers(newLayers);
                    }
                    resolve(newLayer.uuid);
                }).catch(err => {
                    reject('添加图层失败');
                })
            } else {
                resolve(layers[idx]?.uuid);
            }
        })
    })
}